const DEFAULT_VOLUME = 0.65;
const HINT_STORAGE_KEY = 'pm-audio-hint-seen';

function fadeVolume(audio, target, durationSec) {
  const start = audio.volume;
  const durationMs = durationSec * 1000;
  const startTime = performance.now();

  function step(now) {
    const progress = Math.min((now - startTime) / durationMs, 1);
    audio.volume = start + (target - start) * progress;
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

function initAudioHint(button, hint) {
  if (!button) return () => {};

  let hideTimer = 0;

  const dismissHint = () => {
    if (hideTimer) {
      window.clearTimeout(hideTimer);
      hideTimer = 0;
    }
    button.classList.add('audio-toggle--hint-done');
    if (hint) {
      hint.classList.remove('visible');
      hint.classList.add('dismissed');
    }
    sessionStorage.setItem(HINT_STORAGE_KEY, '1');
  };

  if (sessionStorage.getItem(HINT_STORAGE_KEY)) {
    button.classList.add('audio-toggle--hint-done');
    return dismissHint;
  }

  window.setTimeout(() => {
    if (hint) hint.classList.add('visible');
  }, 4000);

  hideTimer = window.setTimeout(dismissHint, 12000);

  return dismissHint;
}

export function initAudioToggle(button, src) {
  if (!button || !src) return;

  const hint = document.getElementById('audioHint');
  const dismissHint = initAudioHint(button, hint);

  const audio = new Audio(src);
  audio.loop = true;
  audio.preload = 'auto';
  audio.volume = 0;

  let isPlaying = false;

  button.addEventListener('click', async () => {
    dismissHint();

    if (!isPlaying) {
      try {
        await audio.play();
        fadeVolume(audio, DEFAULT_VOLUME, 2);
        isPlaying = true;
        button.setAttribute('aria-pressed', 'true');
      } catch {
        /* autoplay policies or load errors — leave toggle off */
      }
      return;
    }

    fadeVolume(audio, 0, 1.5);
    isPlaying = false;
    button.setAttribute('aria-pressed', 'false');
    window.setTimeout(() => {
      if (!isPlaying) {
        audio.pause();
        audio.currentTime = 0;
      }
    }, 1500);
  });
}
